import { BaseApi } from './BaseApi';
export class TagApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    getTag(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('tag'),
            params: {
                id,
            },
        });
    }
    getAllTags() {
        return this.providers.makeRequest({
            route: this.buildRoute('tags'),
        });
    }
    deleteTag(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('tag'),
            method: 'DELETE',
            params: {
                id,
            },
        });
    }
    deleteAllTags() {
        return this.providers.makeRequest({
            route: this.buildRoute('tags'),
            method: 'DELETE',
        });
    }
    updateTag(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('tag'),
            method: 'PATCH',
            data,
            params: {
                id,
            },
        });
    }
    createTag(data) {
        return this.providers.makeRequest({
            route: this.buildRoute('tag'),
            method: 'POST',
            data,
        });
    }
    tagSkills(tagId, ids) {
        return this.providers.makeRequest({
            route: this.buildRoute('tag/skills'),
            method: 'POST',
            data: {
                ids,
            },
            params: {
                id: tagId,
            },
        });
    }
    untagSkills(tagId, ids) {
        return this.providers.makeRequest({
            route: this.buildRoute('tag/skills'),
            method: 'DELETE',
            data: {
                ids,
            },
            params: {
                id: tagId,
            },
        });
    }
    getTaggedSkills(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('tag/skills'),
            method: 'GET',
            params: {
                id,
            },
        });
    }
}
//# sourceMappingURL=tagApi.js.map